var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1242 5.64089C12.3646 6.23125 12.4882 6.86264 12.4881 7.50006C12.4899 8.57035 12.1479 9.61292 11.5125 10.4742C10.8771 11.3355 9.98197 11.97 8.95884 12.2842C7.93571 12.5984 6.83872 12.5758 5.82943 12.2196C4.82015 11.8634 3.95193 11.1925 3.35265 10.3057C2.75336 9.41893 2.4547 8.36313 2.50065 7.29383C2.5466 6.22452 2.93473 5.19824 3.60788 4.36613C4.28102 3.53402 5.20359 2.94008 6.23971 2.67178C7.27583 2.40349 8.37073 2.47503 9.36313 2.87585L10.5498 1.68915C9.61061 1.19089 8.5632 0.931416 7.5 0.933608C6.06955 0.933483 4.67837 1.40159 3.53897 2.26643C2.39956 3.13127 1.57456 4.34529 1.18998 5.72307C0.805399 7.10086 0.882375 8.56665 1.40915 9.89657C1.93593 11.2265 2.88355 12.3474 4.10727 13.0882C5.33099 13.8289 6.76354 14.1487 8.18611 13.9988C9.60868 13.8488 10.9431 13.2374 11.9854 12.2578C13.0278 11.2781 13.7209 9.98427 13.9588 8.57374C14.1967 7.16321 13.9664 5.71358 13.303 4.44627L12.1242 5.64089Z",
    fill: "#0091DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarget);
export default __webpack_public_path__ + "static/media/icon-target.cd3abacc8fe1694d597f3f87d9e0e9ed.svg";
export { ForwardRef as ReactComponent };